import { render } from "./share.vue?vue&type=template&id=6e6c420a&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"

import "./share.vue?vue&type=style&index=0&id=6e6c420a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6c420a"]])

export default __exports__